/**
 * @name MenuApps
 * @description Menú de aplicaciones de Talentry
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { SessionService } from '@services';
import { Environment } from '@config';
import { Icons, MUI, Typography } from '@styles';

class MenuApps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [],
      isAdmin: false,
      anchorEl: null,
    };
  }

  componentDidMount() {
    this.setApps();
  }

  openHandler = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  closeHandler = () => {
    this.setState({ anchorEl: null });
  }

  // Cargar aplicaciones del usuario desde LocalStorage
  setApps = () => {
    const isAdmin = SessionService.hasRoles([3]);
    let apps = [];
    apps = JSON.parse(localStorage.getItem('ls.infoUsuario')).Aplicacion;

    // NOTA: 
    // Si el usuario tiene Indicadores Acumulados pero no Indicadores, entonces se añade la información de la app (icono y nombre) a mostrar.
    // Si el usuario tiene ambas apps (Indicadores e Indicadores Acumulados) se elimina de la lista Indicadores Acumulados ya que es la que se debe mostrar.

    let hasInd = apps.map((app) => app.IdAplicacion).indexOf(3) > -1;
    let hasIndAcc = apps.map((app) => app.IdAplicacion).indexOf(8) > -1;
    let indexIndAcc = apps.findIndex((app) => app.IdAplicacion === 8);

    if (hasIndAcc && !hasInd) {
      apps[indexIndAcc].Aplicacion = 'Indicadores'; // TODO: Etiqueta de diccionaro
      apps[indexIndAcc].Logo = 'https://assets.talentry.io/icons/appicons/metrics.png';
    } else if (hasIndAcc && hasInd) {
      apps.splice(indexIndAcc, 1);
    }

    // Si el usuario no es Admin se elimina Check In de la lista.
    let hasCheckIn = apps.map((app) => app.IdAplicacion).indexOf(16) > -1;
    if (!isAdmin && hasCheckIn) {
      let indexCheckIn = apps.findIndex((app) => app.IdAplicacion === 16);
      apps.splice(indexCheckIn, 1);
    }

    this.setState({ apps, isAdmin });
  }

  // Redireccionar a la aplicación
  goToApp = (app) => {
    // console.log('goToApp', app);
    let URL = Environment.getCurrent().domain;
    // console.log('URL', URL);
    switch (app.IdAplicacion) {
      case 1: // Configuración
        URL += 'configuracion/dashboard';
        break;

      case 2: // Administración
        URL += 'administracion/dashboard';
        break;

      case 3: // Indicadores
        URL += 'indicadores/plan';
        break;

      case 4: // Reconocimientos
        URL += 'talentos';
        break;

      case 5: // Mis datos
        URL += 'datos/misDatos';
        break;

      case 6: // Evaluaciones
        URL += 'evaluaciones/dashboard';
        break;

      case 8: // Indicadores Acumulados
        URL += 'indicadores/acumulados';
        break;

      case 9: // Plan de Desarrollo
        URL = `${URL.substring(0, URL.length - 2)}development-plan`;
        break;

      case 10: // Academy
        URL = `${URL.substring(0, URL.length - 2)}academy`;
        break;

      case 11: // Organigrama
        URL += 'organigrama/chart';
        break;

      case 12: // Auditoría
        URL = `${URL.substring(0, URL.length - 2)}audit`;
        break;

      case 13: // Comunicación
        URL = `${URL.substring(0, URL.length - 2)}communication`;
        break;

      case 14: // Sueldos y Promociones
        URL = `${URL.substring(0, URL.length - 2)}salary-promotions`;
        break;

      case 15: // Dashboards
        URL = `${URL.substring(0, URL.length - 2)}dashboards`;
        break;

      case 16: // Check In
        URL = `${URL.substring(0, URL.length - 2)}check-in`;
        break;

      case 17: // Help Desk
        URL = `${URL.substring(0, URL.length - 2)}helpdesk`;
        break;

      case 18: // Reclutamiento
        URL = `${URL.substring(0, URL.length - 2)}recruitment`;
        break;

      case 19: // Expediente 360
        URL = `${URL.substring(0, URL.length - 2)}org-chart-360`;
        break;

      case 20: // Buzón de denuncias
        URL = `${URL.substring(0, URL.length - 2)}mailbox`;
        break;

      case 21: // Centro de Ayuda
        URL = `${URL.substring(0, URL.length - 2)}help-center`;
        break;

      default:
        break;
    }

    window.location.href = URL;
  }

  // Redireccionar al Home
  goHome = () => {
    let URL = Environment.getCurrent().domain;
    window.location.href = `${URL.substring(0, URL.length - 2)}talentry/#/home`;
  }

  render() {
    const { apps, anchorEl } = this.state;
    return (
      <>
        <Styled.BoxTopbarIcon onClick={this.openHandler}>
          <MUI.Tooltip title={i18n.t('GenericMessages.apps')}>
            <Icons.Apps />
          </MUI.Tooltip>
        </Styled.BoxTopbarIcon>

        <Styled.Popover
          open={Boolean(anchorEl)}
          onClose={this.closeHandler}
          anchorEl={anchorEl}
        >
          <Styled.MenuHeader>
            <Styled.BoxHome
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100%"
              width="100%"
              onClick={this.goHome}
            >
              <Icons.Home />
              <Typography.Text>{i18n.t('Topbar.home')}</Typography.Text>
            </Styled.BoxHome>
          </Styled.MenuHeader>

          {/* <MenuItem> */}
          <Styled.BoxApps>
            {apps.map((app, i) => {
              if (app.IdAplicacion !== 8) { // Indicadores Acumulados
                return (
                  <Styled.BoxRow
                    key={i}
                    apps={apps.length}
                  >
                    <Styled.BoxApp onClick={() => this.goToApp(app)}>
                      <Styled.AppImage
                        src={app.Logo}
                        alt={app.Aplicacion}
                      />
                      <Styled.AppText>
                        {app.Aplicacion}
                      </Styled.AppText>
                    </Styled.BoxApp>
                  </Styled.BoxRow>
                );
              }
              return null;
            })}
            {apps.length === 0 && (
              <Styled.BoxNoApps>
                <Typography.Text>{i18n.t('Topbar.noApps')}</Typography.Text>
              </Styled.BoxNoApps>
            )}
          </Styled.BoxApps>
          {/* </MenuItem> */}
        </Styled.Popover>
      </>
    );
  }
}

MenuApps.propTypes = {
  // History router.
  history: PropTypes.object
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.BoxTopbarIcon = styled(MUI.ButtonText)`
  &.MuiButton-root{
    display: flex;
    min-width: 60px;
    width: 60px;
    height: 60px;
    padding: 12px;
    margin: 0;

    &:hover {
      text-decoration: none;
      background-color: ${(props) => props.theme.colors.greyHover};
      border-radius: 0%;
    }
  }
`;

Styled.AppImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  margin: auto;
`;

Styled.AppText = styled(Typography.Text)`
  font-family: 'Bryant Pro Medium';
  font-size:  ${(props) => props.theme.typography.smallText};
  margin: auto;
`;


Styled.BoxHome = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  .MuiSvgIcon-root {
    margin-right: 12px;
    font-size: 20px;
  }
`;

Styled.BoxApps = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  min-width: 180px;
  max-width: 548px;
  min-height: 110px;
  max-height: 470px;    
  overflow-y: auto;
  scrollbar-width: thin !important; /* Scrollbar Firefox */
`;

Styled.BoxRow = styled.div`
  display: flex;
    width: ${(props) => {
    if (props.apps === 1) {
      return '100%';
    } else if (props.apps === 2) {
      return '50%';
    } else {
      return '33.3%';
    }
  }};
`;

Styled.BoxApp = styled(MUI.ButtonText)`
  &.MuiButton-root {
    width: 100%;
    height: 110px;
    min-width: 180px;
    padding: 12px;
    margin: 0;
    border-radius: 0;
    
    &:hover {
      text-decoration: none;
      background: ${(props) => props.theme.colors.greyHover};
    }
  }

  .MuiButton-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;

Styled.BoxNoApps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

// *************************************
// GLOBAL STYLED COMPONENTS             
// *************************************

Styled.Popover = styled(MUI.Popover)`
  .MuiPopover-paper {
    max-height: 520px;
    max-width: 548px;
  }
`;

Styled.MenuHeader = styled(MUI.MenuHeader)``;

export default MenuApps;
